export default [] = getMenu(
  parseInt(localStorage.getItem("RoleId")),
  parseInt(localStorage.getItem("DepartmentId")),
  (localStorage.getItem("DefinitionsMenuVisibleCheck") || '').toLowerCase() === "true"
);

function getMenu(roleId, departmentId, definitionsMenuVisibleCheck) {
  let menu = [];
  const informationPanel = fillInformationPanel();
  menu.push(informationPanel);
  const clients = fillClients();
  menu.push(clients);
  const owners = fillOwners();
  menu.push(owners);
  const matters = fillMatters();
  menu.push(matters);

  const accounting = fillAccounting(roleId, departmentId);
  menu.push(accounting);

  const reports = fillReports();
  menu.push(reports);
  const wildCards = (parseInt (localStorage.getItem("EmployeeId")) === 21) || (parseInt (localStorage.getItem("EmployeeId")) === 59)
  if ([1, 2].includes(roleId) || definitionsMenuVisibleCheck || wildCards) {
    const definitions = fillDefinitions();
    menu.push(definitions);
  }
  return menu;
}

function fillInformationPanel() {
  return {
    title: "Information Panel",
    icon: "HomeIcon",
    route: "Home",
  };
}

function fillClients() {
  return {
    title: "Clients",
    icon: "UsersIcon",
    route: "Clients",
  };
}

function fillOwners() {
  return {
    title: "Owners",
    icon: "UsersIcon",
    route: "Owners",
  };
}

function fillMatters() {
  return {
    title: "Matter",
    icon: "BriefcaseIcon",
    route: "Matter",
  };
}

function fillAccounting(roleId, departmentId) {
  let data = {
    title: "Accounting",
    icon: "BarChartIcon",
    children: [
      {
        title: "Invoice",
        route: "Invoice",
      },
      {
        title: "CreditNotes",
        route: "CreditNotes",
      },
      {
        title: "Payment",
        route: "Payment",
      },
      // {
      //   title: "InvoiceApproval",
      //   route: "InvoiceApprovalList", //Depricated
      // },
      {
        title: "CostAccounting",
        route: "CostAccounting",
      },
      {
        title: "Vouchers",
        route: "Vouchers",
      },
      {
        title: "InvoiceDetailReport",
        route: "InvoiceDetailReport",
      },
      {
        title: "Law Ledes",
        route: "LawLedes",
      },
      {
        title: "PO Numbers",
        route: "LawPoNumber",
      }
    ],
  };
  if (!(roleId === 1 || departmentId === 2)) {
    data.children = data.children.filter(
      (m) => (m.title == "Invoice" || m.title == "CreditNotes")
    );
  }
  return data;
}

function fillReports() {
  return {
    title: "Reports",
    icon: "BookOpenIcon",
    children: [
      {
        title: "Matter",
        children: [
          {
            title: "MatterReport",
            route: "MatterReport",
          },
          {
            title: "LawyerDailyworkReport",
            route: "LawyerDailyworkReport",
          },
          {
            title: "LawLawyerInvoiceReport",
            route: "LawLawyerInvoiceReport",
          },
          {
            title:
              "LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport",
            route:
              "LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport",
          },
        ],
      },
    ],
  };
}

function fillDefinitions() {
  return {
    title: "Definitions",
    icon: "AlignCenterIcon",
    children: [
      {
        title: "People",
        children: [
          {
            title: "Employee",
            route: "Employee",
          },
          {
            title: "Mediators",
            route: "Mediator",
          },          
          {
            title: "Law Counter Party Sub Type",
            route: "LawCounterPartySubType",
          },
          {
            title: "Law Counter Party Type",
            route: "LawCounterPartyType",
          },          
          {
            title: "Law Counter Party Attorney",
            route: "LawCounterPartyAttorney",
          },
          {
            title: "Law Counter Party",
            route: "LawCounterParty",
          },
          {
            title: "Law Authority Representative",
            route: "LawAuthorityRepresentative",
          },
          {
            title: "Law Authority Category",
            route: "LawAuthorityCategory",
          },
          {
            title: "Law Authority Sub Category",
            route: "LawAuthoritySubCategory",
          },
          {
            title: "Law Authority Type",
            route: "LawAuthorityType",
          },
          {
            title: "Law Authority",
            route: "LawAuthority",
          },
        ],
      },
      {
        title: "Accounting",
        children: [
          {
            title: "Law Activity",
            route: "LawActivity",
          },
          {
            title: "Law Dailywork Description",
            route: "LawDailyworkDescription",
          },
          {
            title: "Invoice Code Report",
            route: "InvoiceCodeReport",
          },
          {
            title: "Law Note To Be On Invoice",
            route: "LawNoteToBeOnInvoice",
          },
          {
            title: "Law Ledes Code Type",
            route: "LawLedesCodeType",
          },
          {
            title: "Law Ledes Type",
            route: "LawLedesType",
          },     
          {
            title: "Standard Invoice Codes",
            route: "StandardInvoiceCodes",
          },     
        ],
      },
      {
        title: "Operation",
        children: [
          {
            title: "Law Matter Sub Subject",
            route: "LawMatterSubSubject",
          },
          {
            title: "Law Matter Subject",
            route: "LawMatterSubject",
          },          
          {
            title: "Law Subject",
            route: "LawSubject",
          },
          {
            title: "Law Matter Status",
            route: "LawMatterStatus",
          },
          {
            title: "Law Document Content Type",
            route: "LawDocumentContentType",
          },
          {
            title: "Law Matter File Type",
            route: "LawMatterFileType",
          },
          {
            title: "Law Matter Type",
            route: "LawMatterType",
          },
          {
            title: "İşlem Alt Klasörleri",
            route: "LawMatterTypeSubFolder",
          },
          {
            title: "Law Product Category",
            route: "LawProductCategory",
          },
          {
            title: "Law Damages Claim Type",
            route: "LawDamagesClaimType",
          },
          {
            title: "Law Trade Fair Subject",
            route: "LawTradeFairSubject",
          },
          {
            title: "Law Trade Fair Center",
            route: "LawTradeFairCenter",
          },
          {
            title: "Law Trade Fair",
            route: "LawTradeFair",
          },
          {
            title: "Law Type Of Violation",
            route: "LawTypeOfViolation",
          },
          {
            title: "Law Professional Investigation Type",
            route: "LawProfessionalInvestigationType",
          },
          {
            title: "Law Professional Investigation Region",
            route: "LawProfessionalInvestigationRegion",
          },
          {
            title: "Law Security Deposit Type",
            route: "LawSecurityDepositType",
          },
          {
            title: "Law Security Deposit Method",
            route: "LawSecurityDepositMethod",
          },
          {
            title: "Law Security Deposit Client Refund Method",
            route: "LawSecurityDepositClientRefundMethod",
          },
        ],
      },
      {
        title: "Results",
        children: [
          {
            title: "Law Matter Process Result",
            route: "LawMatterProcessResult",
          },
          {
            title: "Law Mediation Result",
            route: "LawMediationResult",
          },  
          {
          title: "Law Expert Opinion Outcome",
          route: "LawExpertOpinionOutcome",
          },
          {
            title: "Law Decision",
            route: "LawDecision",
          },
          {
            title: "Law Matter Out Come",
            route: "LawMatterOutcome",
          },
          {
            title: "Law EventType",
            route: "LawEventType",
          },
        ]
      },
      ]
    }
  };
